define('lib/Podio.SingleSignOn',['require','underscore','jquery','lib/Podio.Router','lib/Podio.Routes','lib/Podio.UI','lib/Podio.Event.UI','signals','lib/Podio.Utils'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var router = require('lib/Podio.Router');
  var routes = require('lib/Podio.Routes');
  var podioUI = require('lib/Podio.UI');
  var eventUI = require('lib/Podio.Event.UI');
  var signalsLib = require('signals');
  var podioUtils = require('lib/Podio.Utils');

  var signals = {
    onOAuthComplete : new signalsLib.Signal()
  };

  var providerOptions = {
    sharefile_limited: {
      login: true,
      width: 950,
      height: 475,
      icon: 'provider-icon-sharefile',
      trackingName: 'SharefileLimited',
      humanizedName: 'ShareFile'
    },
    google: {
      login: true,
      width: 700,
      height: 475,
      icon: 'provider-icon-google',
      trackingName: 'GAppsConnect',
      humanizedName: 'Google'
    },
    live: {
      login: true,
      status: 'active',
      width: 950,
      height: 475,
      icon: 'provider-icon-microsoft',
      trackingName: 'Live',
      humanizedName: 'Microsoft'
    },
    apple: {
      login: podioUtils.showFeature('apple_sso'),
      status: 'active',
      width: 950,
      height: 475,
      icon: 'provider-icon-apple',
      trackingName: 'Apple',
      humanizedName: 'Apple'
    },
    sharefile: {
      login: false,
      width: 950,
      height: 475,
      icon: 'provider-icon-sharefile',
      trackingName: 'SharefileLegacy',
      humanizedName: 'ShareFile (Citrix)'
    },
    citrix: {
      login: false,
      width: 980,
      height: 650
    },
    boxnet: {
      login: false,
      width: 1050,
      height: 475
    },
    dropbox: {
      login: false,
      width: 900,
      height: 600
    },
    evernote: {
      login: false,
      width: 800,
      height: 475
    },
    ubuntu_one: {
      login: false,
      width: 1000,
      height: 610
    },
    sugarsync: {
      login: false,
      width: 360,
      height: 360
    },
    yousendit: {
      login: false,
      width: 360,
      height: 440
    },
    exchange: {
      login: false,
      width: 360,
      height: 636
    }
  };

  function signin(provider, options) {
    sso(provider, 'signin', options);
  }

  function connect(provider, options) {
    sso(provider, 'connect', options);
  }

  function sso(provider, subtype, options) {
    options = options || {};

    if (providerOptions[provider]) {
      options['width'] = providerOptions[provider]['width'];
      options['height'] = providerOptions[provider]['height'];
    }

    if( _.include(['sugarsync', 'yousendit', 'exchange'], provider) ) {
      return connectWithCredentials(provider, options);
    }

    var url = router.getGlobalUrl() + routes.sso_start_path({'provider': provider, 'subtype': subtype});
    var width = options.width || 700;
    var height = options.height || 475;

    popup(url, width, height);
  }

  function connectWithCredentials(provider, options) {
    var url = router.getGlobalUrl() + routes.sso_start_credentials_path({'format': 'html', 'provider': provider});

    popup(url, options.width, options.height);
  }

  function connectWithTeaser(provider, options) {
    var url = router.getGlobalUrl() + routes.sso_new_path({'format': 'html', 'provider': provider});

    options = options || {};
    var width = options.width || 1000;
    var height = options.height || 650;

    popup(url, width, height);
  }

  function windowPositionMap(width, height) {
    var elmWindow = $(window),
        offsetY = window.screenY || window.screenTop || 0,
        offsetX = window.screenX || window.screenLeft || 0;

    var topPosition = (elmWindow.height() - height) / 2 + offsetY,
        leftPosition = (elmWindow.width() - width) / 2 + offsetX;

    return {topPosition: topPosition, leftPosition: leftPosition};
  }

  function popup(url, width, height) {
    var position = windowPositionMap(width, height);

    var popupOptions = [
      "width={0}".format(width),
      "height={0}".format(height),
      "top={0}".format(position['topPosition']),
      "left={0}".format(position['leftPosition']),
      "toolbar=no", "location=yes", "scrollbars=yes", "resizable=yes"
    ];

    var openedPopup = window.open(url, "podio_import", popupOptions.join(","));

    if (!_.isNull(openedPopup)) {
      openedPopup.focus();
    }
  }

  function oAuthCompleteCallback(data_as_json) {
    var data = JSON.parse(data_as_json);
    signals.onOAuthComplete.dispatch(data);
  }

  function onPopupExchangeFormSubmitted(elmTarget) {
    var elmButton = elmTarget.find('.exchange-start-sso');
    podioUI.disableButtonWithLoader(elmButton);
  }

  eventUI.bind('submit', '.sso-exchange-config-form', onPopupExchangeFormSubmitted, true);

  return {
    signals: signals,
    signin: signin,
    connect: connect,
    connectWithTeaser: connectWithTeaser,
    oAuthCompleteCallback: oAuthCompleteCallback,
    popup: popup,
    providerOptions:providerOptions
  };

});

